import React from 'react';
import { Formik, Form, useField } from 'formik';
import * as Yup from 'yup';
import { Container, Row, Col, Button } from 'react-bootstrap';

import useAuth from '../../hooks/useAuth';

//  Error message if any input is invalid
const InputFeedback = ({ error }) =>
	error ? <div className="form__error">{error}</div> : null;

const TextInput = ({ label, ...props }) => {
	const [field, meta] = useField(props);
	return (
		<>
			<div className="form__group field">
				<input className={`form__field`} {...field} {...props} />
				<label htmlFor={props.id || props.name} className="form__label">
					{label}
				</label>
				{meta.touched && meta.error && (
					<InputFeedback error={meta.error} />
				)}
			</div>
		</>
	);
};

const LoginForm = () => {
	const { loginUser, error } = useAuth();

	return (
		<Formik
			initialValues={{
				email: '',
				password: '',
			}}
			validationSchema={Yup.object({
				email: Yup.string()
					.email('⚠️ Invalid email')
					.required('⚠️ Mandatory'),
				password: Yup.string().required('⚠️ Mandatory'),
			})}
			onSubmit={async (values, { setSubmitting }) => {
				await loginUser(values);
				setSubmitting(false);
			}}>
			{formik => (
				<Form className="mb-5 mt-4">
					<div className="top-form m-4">
						<Container>
							<Row>
								<Col className="text-center">
									<h1 className="title">Login</h1>
									<p className="subtitle text-center">
										Welcome to the administrator page, if
										you are not one, please go back!
									</p>
								</Col>
							</Row>
						</Container>
					</div>
					<div className="bottom-form">
						<Container>
							<div className="form-box jumbotron jumbotron-fluid bg-light">
								<Container fluid>
									<Row>
										<Col>
											<Container className="py-3">
												<Row className="mb-3">
													<Col xs={12}>
														<TextInput
															label="Email"
															name="email"
															type="email"
															placeholder="Email"
														/>
													</Col>
													<Col xs={12}>
														<TextInput
															label="Password"
															name="password"
															type="password"
															placeholder="**********"
														/>
													</Col>
												</Row>

												<Row className="text-end">
													<Col>
														<Button
															type="submit"
															variant="primary"
															disabled={
																formik.isSubmitting ||
																!formik.isValid
															}
															className="fs-10">
															Login
														</Button>
														{error && (
															<div>Erro</div>
														)}
													</Col>
												</Row>
											</Container>
										</Col>
									</Row>
								</Container>
							</div>
						</Container>
					</div>
				</Form>
			)}
		</Formik>
	);
};

export default LoginForm;
